import React from 'react'
import { Users, AlertTriangle, RefreshCw } from 'lucide-react'

const heure = (iso) => iso ? new Date(iso).toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }) : ''

export function PresenceBanner({ autres }) {
  if (!autres?.length) return null
  const noms = autres.map(a => a.user_nom || 'Un gestionnaire')
  return (
    <div className="flex items-center gap-3 px-4 py-2.5 rounded-xl border border-orange-300 bg-orange-50 text-orange-900 text-sm" data-testid="presence-banner">
      <Users size={16} className="text-orange-600 shrink-0" />
      <span>
        <strong>{noms.join(', ')}</strong> {autres.length > 1 ? 'consultent' : 'consulte'} également ce dossier en ce moment.
        Coordonnez-vous avant de modifier.
      </span>
    </div>
  )
}

export function ConflitEditionModal({ conflit, onRecharger, onFermer }) {
  if (!conflit) return null
  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4" data-testid="conflit-edition-modal">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md">
        <div className="px-5 py-4 border-b border-slate-200 flex items-center gap-2">
          <AlertTriangle size={18} className="text-red-600" />
          <h3 className="font-semibold text-slate-900">Modification non enregistrée</h3>
        </div>
        <div className="p-5 space-y-3 text-sm text-slate-700">
          <p>
            Ce dossier a été modifié par <strong>{conflit.modifie_par || 'un autre gestionnaire'}</strong>
            {conflit.modifie_le ? ` à ${heure(conflit.modifie_le)}` : ''} depuis que vous l'avez ouvert.
          </p>
          <p>Pour éviter d'écraser ses modifications, votre saisie a été refusée. Rechargez le dossier pour voir la version à jour, puis refaites votre modification si nécessaire.</p>
        </div>
        <div className="px-5 py-4 border-t border-slate-200 flex justify-end gap-3">
          <button onClick={onFermer} className="px-4 py-2 text-sm text-slate-600 hover:text-slate-800" data-testid="conflit-fermer-btn">Fermer</button>
          <button onClick={onRecharger} data-testid="conflit-recharger-btn"
            className="px-4 py-2 bg-slate-800 text-white rounded-lg text-sm font-medium hover:bg-slate-700 flex items-center gap-2">
            <RefreshCw size={14} /> Recharger le dossier
          </button>
        </div>
      </div>
    </div>
  )
}
